import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'
import { ChevronDownIcon } from '@grupoboticario/flora-react-icons'

import { sectionHeaderStyle, sectionTitleStyle, chevronIconContainerStyle, getCollapsibleSectionStyles } from './styles'

const CollapsibleSection = ({ title, isOpen, onToggle, children, variant }) => {
  const { sectionStyles, headerPadding } = getCollapsibleSectionStyles(variant)

  return (
    <Box css={sectionStyles}>
      <Flex align="center" css={sectionHeaderStyle(headerPadding)} justify="space-between" onClick={onToggle}>
        <FloraTypography css={sectionTitleStyle} fontSize="bodyLargeStandard" fontWeight="medium">
          {title}
        </FloraTypography>
        <Box css={chevronIconContainerStyle(isOpen)}>
          <ChevronDownIcon />
        </Box>
      </Flex>
      {isOpen && children}
    </Box>
  )
}

CollapsibleSection.defaultProps = {
  variant: 'default'
}

export default CollapsibleSection
